import { render } from "./BesonderesGebaeude.vue?vue&type=template&id=3a97f4ae"
import script from "./BesonderesGebaeude.vue?vue&type=script&lang=js"
export * from "./BesonderesGebaeude.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__